function Footer() {
    return (
        <>
            <footer className="bg-white rounded shadow p-5 mb-4 mt-4">
                <div className="row">
                    <div className="col-12 col-md-4 col-xl-6 mb-4 mb-md-0">
                        <p className="mb-0 text-center text-lg-start">© 2010-<span className="current-year">2025</span> <a
                            className="text-primary fw-normal" href="https://easycripto.com.br/">JPDSS2020</a>. EasyCripto 3.3</p>
                    </div>
                    <div className="col-12 col-md-8 col-xl-6 text-center text-lg-start">

                        <ul className="list-inline list-group-flush list-group-borderless text-md-end mb-0">
                            <li className="list-inline-item px-0 px-sm-2">
                                <a href="">Sobre</a>
                            </li>
                            <li className="list-inline-item px-0 px-sm-2">
                                <a href="">Cursos</a>
                            </li>
                            <li className="list-inline-item px-0 px-sm-2">
                                <a href="https://www.amazon.com/-/pt/dp/B0FGCXKDYH/ref=tmm_pap_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.TU6KpeWSalm5uHutYX20z2djV3s70sInn0L1_Eh9xLI.c7ZAcC8APjz91Y7EdttYcDkFAE_PufSh7SlxclbV1OQ&qid=1769710931&sr=8-1">Livros</a>
                            </li>
                            <li className="list-inline-item px-0 px-sm-2">
                                <a href="">Contato</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
